import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import Img from "gatsby-image";
import React, { useEffect, useState } from 'react';
// import useSessionState from '../../../shared/hooks/useSessionState';
import ProductService from '../../../services/products';
import SessionService from '../../../services/session';
import './productDetailSection.scss';
import { Link } from "gatsby";
import Icon from "../../../components/atoms/Icon/Icon";
import QualifySectionContent from "../../organisms/qualify-section-content/qualify-section-content";
import CommentsSectionContent from "../../organisms/comments-section-content/comments-section-content";
import useHomeLinkMode from "../../../hooks/useHomeLinkMode";
import useLocaleMode from "../../../hooks/useLocaleMode";
import { gothic, lonchmara } from '../../../_shared/Variables.scss';

const ProductDetailSection = props => {

  const [localLikes, setlocalLikes] = useState([])
  const [isFakeLiked, setisFakeLiked] = useState(false)
  const [isFakeUnLiked, setisFakeUnLiked] = useState(false)
  const [likeValue, setlikeValue] = useState(null)
  const { homeLink } = useHomeLinkMode();
  const [itemsRateDetails, setItemsRateDetails] = useState()
  const [ratingDetail, setRatingDetail] = useState()
  const { country } = useLocaleMode();
  /*Comments variables*/
  const [comments, setComments] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(0);
  const [isLoader, setIsLoader] = React.useState(false)
  const [commentPlus, setCommentPlus] = React.useState(true)
  const limit = 2;

  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <p className="f-card-product-description f-p" >{children}</p>
    }
  }

  const optionsSecond = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        return children && children.length === 1 && typeof children[0] === "string"
          ? children[0]?.replace(/\u00a0/g, " ").replace(/(?:\r\n|\r|\n)/g, '')
          : children
      }
    }
  }

  const formatNumber = (num) => {
    if (num > 999999) {
      return parseInt(num / 1000000, 10).toString() + 'M'
    } else if (num > 999) {
      return parseInt(num / 1000, 10).toString() + 'K'
    } else {
      return num
    }
  }

  const isLiked = (idProduct) => {
    let i
    for (i = 0; i < localLikes.length; i++) {
      if (localLikes[i] === idProduct) {
        return true;
      }
    }

    return false;
  }

  useEffect(() => {
    handleLoadLikes();
    setlocalLikes(localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null ? JSON.parse(localStorage.getItem('LOCAL_LIKES_PRODUCTS')) : [])
  }, [])

  const handleLoadLikes = () => {
    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      ProductService.getAnomLikes().then(res => {

        // setlistLikes(res.data)
        setlikeValue(res.data.filter(item => { if (item.idCMS === props.idProduct) { return item.like } })[0].like)

      }).catch(e => console.log(e))
    } else {
      localStorage.removeItem('LOCAL_LIKES_PRODUCTS');

      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }

      ProductService.getAuthLikes(config).then(res => {
        for (let index = 0; index < res.data.length; index++) {
          // console.log(res.data[index]);

          if (res.data[index].userLike) {
            if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
              const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
              localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.concat(res.data[index].idCMS)))
              setlocalLikes(copyLocalLikes.concat(res.data[index].idCMS))
            } else {
              localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([res.data[index].idCMS]))
              setlocalLikes([res.data[index].idCMS])
            }
          }
        }
        setlikeValue(res.data.filter(item => { if (item.idCMS === props.idProduct) { return item.like } })[0].like)
      }).catch(e => console.log(e));
    }
  }
  const handleUnLike = () => {
    const payload = {
      type: "PRODUCTO",
      idCMS: props.idProduct,
    }

    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {

      ProductService.setAnomUnLikes(payload).then(res => {
        if (res.status === 200) {
          const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
          localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.filter(item => item !== props.idProduct)))
          setlocalLikes(copyLocalLikes.filter(item => item !== props.idProduct))
          isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
        } else {
          console.log(res);
        }
      }).catch(e => console.log(e));
    } else {
      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }

      ProductService.setAuthUnLikes(payload, config).then(res => {
        if (res.status === 200) {
          const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
          localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.filter(item => item !== props.idProduct)))
          setlocalLikes(copyLocalLikes.filter(item => item !== props.idProduct))
          isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
        } else {
          console.log(res);
        }
      }).catch(e => console.log(e));
    }
  }

  const handleLike = () => {
    const payload = {
      type: "PRODUCTO",
      idCMS: props.idProduct,
    }

    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      ProductService.setAnomLikes(payload).then(res => {
        if (res.status === 200) {
          if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.concat(props.idProduct)))
            setlocalLikes(copyLocalLikes.concat(props.idProduct))
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          } else {
            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([props.idProduct]))
            setlocalLikes([props.idProduct])
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          }
        } else {
          console.log(res);
        }
      }).catch(e => console.log(e));

    } else {
      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }
      ProductService.setAuthLikes(payload, config).then(res => {
        if (res.status === 200) {
          if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.concat(props.idProduct)))
            setlocalLikes(copyLocalLikes.concat(props.idProduct))
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          } else {
            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([props.idProduct]))
            setlocalLikes([props.idProduct])
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          }
        } else {
          console.log(res);
        }
      }).catch(e => console.log(e));
    }
  }

  const handleClickShowModal = () => {
    let productCategory = props.slug === "mujeres" ? "Mujer" :
      props.slug === "hombres" ? "Hombre" :
        "Unisex";
    try {
      window.dataLayer.push({
        'Category': 'Ecommerce',
        'Action': 'Add to cart',
        'Dimension 5': 'Quiero comprar',
        'Product Name': props.title,
        'Product Id': props.title,
        'Product Brand': 'TENA',
        'Product Category': productCategory,
        'Product Variant': props.nivelIncontinencia.json.content[0].content[1].value,
      });
    } catch (e) {
      console.log('dataLayer Error', e);
    }
    props.setModalVisibility(true)
    // if (props.haveRetails && props.paramRetails.length > 1) {
    //   props.setModalVisibility(true)
    // } else if (props.haveRetails && props.paramRetails.length === 1) {
    //   window.open(props.paramRetails[0].redireccionRetail, '_blank');
    // }
  }

  const handleTagManager = () => {
    let productCategory = props.slug === "mujeres" ? "Mujer" :
      props.slug === "hombres" ? "Hombre" :
        "Unisex";
    try {
      window.dataLayer.push({
        'Category': 'Ecommerce',
        'Action': 'Add to cart',
        'Dimension 5': 'Muestra gratis',
        'Product Name': props.title,
        'Product Id': props.title,
        'Product Brand': 'TENA',
        'Product Category': productCategory,
        'Product Variant': props.nivelIncontinencia.json.content[0].content[1].value,
      });
    } catch (e) {
      console.log('dataLayer Error', e);
    }
  }

  const handleRenderButtons = () => (
    <div className="f-buttons-header">
      {props.buttonsRetails && props.buttonsRetails.map((value, index) => {
        if (value) {
          if (value.shop) {
            if (false !== props.haveRetails && props.paramRetails && props.paramRetails.length >= 1) {
              return (
                <button
                  key={index}
                  className={`f-buttons-header-button-${index}`}
                  onClick={() => {
                    handleClickShowModal()
                  }}
                >
                  {value.title}
                  <div className="f-img-container">
                    {value.icon &&
                      // <Img fluid={value.icon} className="f-shop-logo"
                      // alt={value.icon.description}  /> 
                      <img
                        className="f-shop-logo"
                        src={value.icon}
                        alt={value.icon.description}
                      />

                    }
                  </div>
                </button>
              )
            } else {
              return null
            }
          } else {
            return (
              <Link
                key={index}
                className={`f-buttons-header-button-${index}`}
                to={value.slug}
                onClick={handleTagManager}
              >
                {value.title}
                <div className="f-img-container">
                  {value.icon &&
                    // <Img fluid={value.icon} className="f-shop-logo"
                    // alt={value.icon.description}  /> 
                    <img
                      className="f-shop-logo"
                      src={value.icon}
                      alt={value.icon.description}
                    />

                  }
                </div>
              </Link>
            )
          }
        }
      })}
      {(!props.isFreeSamples) ?
        <button
          className='f-buttons-header-button-3'
          onClick={() => {
            try {
              window.dataLayer.push({
                'event': 'ga_event_pruebas_y_apruebas',
                'category': 'Detalle producto',
                'action': 'Calificar',
                'label': props.title
              });
            } catch (e) {
              console.log('dataLayer Error', e);
            }
            window.location.href = homeLink + 'productos/' + props.url + '/calificar/'
          }}
        >
          CALIFICAR PRODUCTO
                <div className="f-img-container">
            <Icon icon="icon-star white" size="1" tagtype="span" />
          </div>
        </button>
        :
        null
      }
    </div>
  )

  const renderDrops = (drops, activeDrops) => {
    let nodeArray = []
    for (let index = 0; index < Number(drops); index++) {
      nodeArray.push(
        <svg
          key={index}
          width="24"
          height="35"
          viewBox="0 0 24 35"
        >
          <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="50%" stopOpacity={1} stopColor={props.dropsColor ? props.dropsColor : gothic} />
            <stop offset="50%" stopOpacity={1} stopColor={lonchmara} />
          </linearGradient>
          <path
            className={
              index < Number(activeDrops) ? (activeDrops % 1 == 0.5 && parseInt(index + 0.5) == parseInt(activeDrops)) ? "f-drop--active-medium" : "f-drop f-drop--active" : "f-drop"
            }
            d="M16.68,36.747A11.919,11.919,0,0,1,5,24.586C5,15.465,16.68,2,16.68,2S28.36,15.465,28.36,24.586A11.919,11.919,0,0,1,16.68,36.747Z"
            transform="translate(-5 -2)"
            fill={activeDrops % 1 == 0.5 && parseInt(index + 0.5) == parseInt(activeDrops) ? "url(#grad1)" : "none"}
          />
        </svg>
      )
    }
    return nodeArray
  }

  /*Filter and sort detailRating elements*/
  const setItemsDetailsRate = itemsDetailBack => {
    if (itemsDetailBack?.length < 1) {
      return false
    }

    let listCompare = [5, 4, 3, 2, 1]
    let newList = []
    listCompare.forEach(element => {
      let resultado = itemsDetailBack.find(i => i.qualification == element)
      newList.push(
        resultado != undefined ? resultado : { qualification: element, numberVotes: 0 }
      )
    })
    setItemsRateDetails(newList)
  }

  /*GetComments and load more comments*/
  const handleGetComments = () => {
    setIsLoader(true)

    let payload = {
      idProduct: props.idProduct,
      limit,
      page: currentPage,
      countryId: country.codigoDelPais,
    }

    ProductService.getComments(payload)
      .then(res => {
        setComments(comments => comments.concat(res.data))
        setCurrentPage(page => page + 1)
        res.data.length < limit && setCommentPlus(false)
      })
      .catch(error => {
        console.log(
          "🚀 ~ file: comments-section-content.jsx ~ line 39 ~ ProductService.getComments ~ error",
          error
        )
      }).finally(() => setIsLoader(false))
  }

  /*Get comments*/
  useEffect(() => {
    handleGetComments()
  }, [])

  /*Get qualify info*/
  useEffect(() => {
    let payload = {
      idProduct: props.idProduct,
      countryId: country.codigoDelPais,
    }

    ProductService.getQualify(payload)
      .then(res => {
        setRatingDetail(res.data)
      })
      .catch(error => {
        console.log("Error consulta calificación", error)
      })

    ProductService.getQualifyDetail(payload)
      .then(res => {
        setItemsDetailsRate(res.data)
      })
      .catch(error => {
        console.log("Error consulta calificación", error)
      })
  }, [])

  // const newSlug = props.slug.substring(props.slug.lastIndexOf('/') + 1);
  const newSlug = props.slug;
  return (
    <section className="f-product-detail-section">
      <div className="f-product-detail-section-primary" >
        <label className={`f-${newSlug} f-mobile-title`} >{props.title}</label>
        <div className="image" >
          {props.isFreeSamples && props.imagenProducto !== null ?
            <Img fluid={props.imagenProducto.fluid} />
            :
            <Img fluid={props.imagenProducto && props.imagenProducto.fluid} alt={props.imagenProducto && props.imagenProducto.description} />
          }
          {(!props.isFreeSamples && !props.isMobile) ?
            <div className="f-likes-container">
              {isLiked(props.idProduct) ?
                <div className="f-icon-heart" onClick={() => handleUnLike()}></div>
                :
                <div className="f-icon-heart-gray" onClick={() => handleLike()}></div>
              }
              <label className="f-count-likes">{formatNumber(isFakeLiked ? likeValue + 1 : isFakeUnLiked ? likeValue - 1 : likeValue)}</label>
            </div>
            :
            null
          }
          {!props.isMobile && handleRenderButtons()}
        </div>
        {(!props.isFreeSamples && props.isMobile) ?
          <div className="f-likes-container">
            {isLiked(props.idProduct) ?
              <div className="f-icon-heart" onClick={() => handleUnLike()}></div>
              :
              <div className="f-icon-heart-gray" onClick={() => handleLike()}></div>
            }
            <label className="f-count-likes">{formatNumber(isFakeLiked ? likeValue + 1 : isFakeUnLiked ? likeValue - 1 : likeValue)}</label>
          </div>
          :
          null
        }
        <div className="description" >
          {props.isMobile && handleRenderButtons()}
          <h1 className={`f-${newSlug} f-card-product-title f-h1`} >{props.title}</h1>
          {props.descripcion && documentToReactComponents(props.descripcion.json, options)}
          <div className="f-card-product-resena f-p" >
            {props.nivelIncontinencia && documentToReactComponents(props.nivelIncontinencia.json)}
            <div>{props.numeroGotas && renderDrops(props.numeroGotas, props.numeroGotasLlenas)}</div>
          </div>
          {props.atributes && <div className="f-card-product-atributes" >
            {props.atributes.map((attr, key) =>
              <div className="f-atribute" key={key} >
                <img src={attr.imagenDelSello.file.url} alt={attr.imagenDelSello.description} />
                <p>{documentToReactComponents(attr.descripcionDelSello.json, optionsSecond)}</p>
              </div>
            )}
          </div>
          }
          {props.sizes &&
            <div className="f-card-product-sizes" >
              <h4 className="f-title" >{props.lbtalla}</h4>
              <div className="f-sizes" >
                {props.sizes.map((size, key) => {
                  const isSizeSelected = (props.samples.find(sample => sample.size === size)) || (props.samplesSent && (props.samplesSent.find(s => s.size === size && s.id === props.idProduct)));
                  return <div
                    className={`f-sizes-size ${size === props.sizeSelected ? `f-sizes-size-select ${size.toLowerCase()}` : isSizeSelected ? 'f-sizes-size-selected' : ''}`}
                    onClick={() => !isSizeSelected && props.selectSize(size)} key={key} >{size}
                  </div>
                })}
              </div>
            </div>
          }
        </div>
      </div>

      {!props.isFreeSamples ?
        <>
          <hr className="f-custom-hr" />
          {ratingDetail &&
            (ratingDetail?.productAvg !== 0 || ratingDetail?.totalQualifications !== 0) &&
            itemsRateDetails &&
            <QualifySectionContent isMobile={props.isMobile} ratingDetail={ratingDetail} itemsRateDetails={itemsRateDetails} />
          }
          {comments && comments.length > 0 &&
            <CommentsSectionContent
              isMobile={props.isMobile}
              comments={comments}
              currentPage={currentPage}
              isLoader={isLoader}
              commentPlus={commentPlus}
              limit={limit}
              handleGetComments={handleGetComments}
            />
          }
        </>
        :
        null
      }
      {props.beneficios}
      {props.products}
    </section>
  )
}

export default ProductDetailSection;